import { PropType } from 'vue'
import { CoursePriceRange } from '__generated__/globalTypes'

export const props = {
  sort: {
    type: String,
    default: () => undefined
  },
  page: {
    type: Number,
    default: () => undefined
  },
  start: {
    type: String,
    default: () => undefined
  },
  end: {
    type: String,
    default: () => undefined
  },
  holes: {
    type: Number,
    default: () => undefined
  },
  players: {
    type: Number,
    default: () => undefined
  },
  lat: {
    type: Number,
    default: () => undefined
  },
  lon: {
    type: Number,
    default: () => undefined
  },
  loc: {
    type: String,
    default: () => undefined
  },
  price: {
    type: String as PropType<CoursePriceRange>,
    default: () => undefined
  },
  clubs: {
    type: String,
    default: () => undefined
  },
  amenities: {
    type: String,
    default: () => undefined
  }
}
